import { BaseIcon, BaseIconProps } from "./BaseIcon";

export function ShutDownIcon(props: BaseIconProps) {
  return (
    <BaseIcon {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.0015 1C16.8299 1 17.5015 1.67158 17.5015 2.5V17.5C17.5015 18.3285 16.8299 19 16.0015 19C15.173 19 14.5015 18.3285 14.5015 17.5V2.5C14.5015 1.67158 15.173 1 16.0015 1ZM11.2999 6.35429C11.7147 7.07138 11.4696 7.98899 10.7526 8.40379C7.61018 10.2216 5.50146 13.6155 5.50146 17.5C5.50146 23.299 10.2025 28 16.0015 28C21.8005 28 26.5015 23.299 26.5015 17.5C26.5015 13.6155 24.3927 10.2216 21.2504 8.40379C20.5332 7.98899 20.2883 7.07138 20.7031 6.35429C21.1178 5.63721 22.0354 5.39217 22.7524 5.80697C26.7837 8.13891 29.5015 12.5012 29.5015 17.5C29.5015 24.9559 23.4574 31 16.0015 31C8.54562 31 2.50146 24.9559 2.50146 17.5C2.50146 12.5012 5.21914 8.13891 9.25038 5.80697C9.96745 5.39217 10.8851 5.63721 11.2999 6.35429Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
}
